var errors = {
  "WrongToken": "WrongToken",
  "WrongLogin": "WrongLogin",
  "WrongTerms": "WrongTerms",
  "TooManyRequests": "TooManyRequests",
  "PasswordNotEqual": "PasswordNotEqual",
  "PasswordLength": "PasswordLength",
  "EmailFormat": "EmailFormat",
  "DuplicateEmail": "DuplicateEmail",
  "DuplicateNick": "DuplicateNick",
  "NickLength": "NickLength",
  "NickFormat": "NickFormat",
  "BlogpostTitleLength": "BlogpostTitleLength",
  "BlogpostLeadLength": "BlogpostLeadLength",
  "BlogpostBodyLength": "BlogpostBodyLength",
  "CommentTitleLength": "CommentTitleLength",
  "CommentLeadLength": "CommentLeadLength"
};
export default errors;